import { Component, forwardRef, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import * as _ from "lodash";
import { isEmptyObject } from "../../common/helper";
import { ConfigurationParameter, Recipe } from "../../model";
import { ParameterService } from "../../service/parameter.service";

@Component({
    selector: 'recipe-parameter-viewer-dialog',
    template: require('./recipe-parameter-viewer-dialog.component.html'),
    styles: [require('./recipe-parameter-viewer-dialog.component.css')]
})
export class RecipeParameterViewerDialogComponent implements OnInit {

    private allParameters: ParameterInfo[] = [];

    loaded: boolean;
    recipe: Recipe;
    visibleParameters: ParameterInfo[];
    parametersByName: { [name: string]: ConfigurationParameter };

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<RecipeParameterViewerDialogComponent>,
        @Inject(forwardRef(() => ParameterService)) private parameterService: ParameterService,
        @Inject(MAT_DIALOG_DATA) data,
    ) {
        this.recipe = _.cloneDeep(data);
    }

    ngOnInit(): void {
        if (isEmptyObject(this.recipe.parameters)) {
            this.loaded = true;
            return;
        }
        this.parameterService.getConfigurationParametersByThingDefinitionId(this.recipe.thingDefinition.id).then(parameters => {
            this.parametersByName = {}
            parameters.forEach(p => this.parametersByName[p.name] = p);

            Object.keys(this.recipe.parameters).forEach(k => {
                let param: ConfigurationParameter = this.parametersByName[k];
                if (param) {
                    this.allParameters.push({
                        group: param.group,
                        name: param.name,
                        label: param.label || param.name,
                        value: this.recipe.parameters[k],
                        unit: param.metric?.unit,
                        useCustomEditor: param.useCustomEditor
                    })
                }
            });
            this.allParameters.sort(this.parameterInfoCompare);
            this.visibleParameters = _.cloneDeep(this.allParameters);
            this.loaded = true;
        });
    }

    doSimpleSearch(body: any): void {
        let key: string = body.key;
        if (key) {
            key = key.toLowerCase();
            this.visibleParameters = this.allParameters.filter(p => p.label?.toLowerCase().includes(key) || p.group?.toLowerCase().includes(key));
        } else {
            this.visibleParameters = _.cloneDeep(this.allParameters);
        }
    }

    private parameterInfoCompare(a: ParameterInfo, b: ParameterInfo) {
        if (a.group < b.group) {
            return -1;
        }
        if (a.group > b.group) {
            return 1;
        }
        if (a.label < b.label) {
            return -1;
        }
        if (a.label > b.label) {
            return 1;
        }
        return 0;
    }
}

class ParameterInfo {
    group: string;
    name: string;
    label: string;
    value: any;
    unit: string;
    useCustomEditor: boolean;
}

